module.exports = __webpack_public_path__ + "img/title.e8c300c7.png";